import { render, staticRenderFns } from "./rmaOrderRD.vue?vue&type=template&id=44b3ce34&"
import script from "./rmaOrderRD.vue?vue&type=script&lang=ts&"
export * from "./rmaOrderRD.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports